import { Domain } from "@app/models/domain.model";
import { Subdomain } from "@app/models/subdomain.model";
import { Site } from "@app/models/site.model";
import { getPromise, graphqlPromise } from "./request-promise";

export interface UserDomainInfo {
	domains: Domain[],
	subdomains: Subdomain[],
}

interface SiteDataset {
	id: number;
	name: string;
	isPhantom?: boolean;
}

interface SitesResponse {
	sites?: Site[];
}

interface DatasetResponse {
	data?: {
		datasets?: SiteDataset[];
	};
}

export function getUserDomainInfo() {
  return getPromise<UserDomainInfo>('api/v1/users/get_user_domain_info', data => data ?? null);
}

export function getSubDomainSite(subDomainId: number) {
  return getPromise<SitesResponse, Site[]>(
		`api/v1/users/${subDomainId}/getSitesFromSubdomain`,
		data => data.sites ?? []
	);
}


export function fetchSiteDatasetsList(siteId:number){
	const query=`query fetchSiteDatasetsList($siteId: ID!){
		datasets(siteId: $siteId){
			id,
			name,
			isPhantom
		}
	}`;

	return graphqlPromise<DatasetResponse, SiteDataset[]>(null, query, { siteId }, data => {
		const datasets = data?.data?.datasets ?? [];

		return datasets.filter(d => d && !d.isPhantom);
	});
}
